// BookingEmbed: inline Google Calendar appointment scheduler iframe.
// Lazy-loads (browser native) so it doesn't block first paint.
//
// If the iframe is blocked / refused by the embedding policy, the parent
// component should provide a fallback (a click-through "Open Calendar" button).

import { cx } from '@lib/utils/classNames';

export interface BookingEmbedProps {
  /** Iframe src — the `?gv=true` Google Calendar appointment schedule URL. */
  src: string;
  /** Accessible title — required. */
  title: string;
  /** Height in px. The iframe fills 100% width of its container. */
  height?: number;
  className?: string;
}

export function BookingEmbed({
  src,
  title,
  height = 600,
  className,
}: BookingEmbedProps) {
  return (
    <iframe
      src={src}
      title={title}
      width="100%"
      height={height}
      loading="lazy"
      className={cx('booking-embed', className)}
      style={{ border: 0, display: 'block' }}
      // Google Calendar requires popups (for sign-in) and same-origin (for the iframe to talk to itself).
      // forms allows the booking form, scripts is required for the scheduler to run.
      sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms"
    />
  );
}
